module.exports = __webpack_public_path__ + "img/ic_file-pending.35d8614d.svg";